<template lang="pug">
    span &nbsp;
    </template>
    
    <script>
    import Api from "@/components/services/Api";

    export default {
      name: 'DashboardCommunity',
      async created() {

        console.log(this.$store.state.token)
        const response = await Api.redirectToCommunity(this.$store.state.token)
        console.log(response)
        console.log(response.data)

        window.location.replace(response.data["url_community"])
        //window.open(response["url_community"], '_blank');//En otra pestaña

      },
    }
    </script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCommunity.vue